import { ComplianceStatus, complianceStatusDisplayNames, ComplianceType } from '@centecomm/portal-service';

const signageStatusDisplayNames = {
    ...complianceStatusDisplayNames,
    [ComplianceStatus.Approved]: 'Approved',
};

const complianceDisplayName = (status: ComplianceStatus, type: ComplianceType): string => {
    if (type === ComplianceType.Signage || type === ComplianceType.Hvac || type === ComplianceType.HvacSvcAgreement)
        return signageStatusDisplayNames[status] || status;

    return complianceStatusDisplayNames[status] || status;
};

export default complianceDisplayName;
